import React, { useCallback } from 'react'
import './ContactModal.scss'
import { useContactModal } from './useContactModal'
import { useRecoilValue } from 'recoil'
import { langState } from '../../../atoms'
import { getText } from '../../../data/langs'

const ContactModal = () => {
  const {
    open,
    showEmailInput,
    email,
    setEmail,
    closeModal,
    handleOverlayClick,
    handleReceiveCv,
    handleSend,
  } = useContactModal()
  const { value } = useRecoilValue(langState)
  const text = useCallback((key) => getText(key, value), [value])

  if (!open) return null

  return (
    <div className="ContactModal" onClick={handleOverlayClick}>
      <div className="card">
        <button className="close" onClick={closeModal} />
        <h2 className="title">{text('contactme')}</h2>
        <div className="info">
          <a href="tel:+261349652096" className="row">
            <span className="icon phone" />
            <span>+261 34 96 520 96</span>
          </a>
          <a href="mailto:marson.laza@gmail.com" className="row">
            <span className="icon mail" />
            <span>marson.laza@gmail.com</span>
          </a>
          <a
            href="https://www.linkedin.com/in/marsonlj"
            target="_blank"
            rel="noopener noreferrer"
            className="row"
          >
            <span className="icon linkedin" />
            <span>Marson John LAZA</span>
          </a>
        </div>
        <div className="cv-section">
          {showEmailInput ? (
            <div className="email-form">
              <input
                type="email"
                className="email-input"
                placeholder={text('youremail')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
              />
              <button className="send-btn" onClick={handleSend}>
                {text('send')}
              </button>
            </div>
          ) : (
            <button className="cv-btn" onClick={handleReceiveCv}>
              {text('receivecv')}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default ContactModal
